import { InstanceOf, Static, String } from 'runtypes'

export const DateString = String.withBrand('DateString').withConstraint((str: string) => {
    const date = new Date(str)
    if (isNaN(date.valueOf())) throw new Error(`Invalid date string "${str}"`)
    else return true
})
export type DateString = Static<typeof DateString>

export const DateType = InstanceOf(Date).withBrand('Date')
export type DateType = Static<typeof DateType>
